'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _elementActions = require('../../../../element/elementActions');

var _analytics = require('../../../../analytics');

var _elementHelper = require('../../../../../common/elements/elementHelper');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        isActive: (0, _elementHelper.isElementLocked)(ownProps.selectedElements.first())
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        handleMouseDown: function handleMouseDown(event) {
            var lockValue = (0, _elementHelper.isElementLocked)(ownProps.selectedElements.first());
            var changes = { locked: !lockValue };
            dispatch((0, _elementActions.updateSelectedElements)({ changes: changes }));

            var firstElementType = ownProps.selectedElements.first().get('elementType');
            var lockedUnlocked = !lockValue ? 'locked' : 'unlocked';
            (0, _analytics.analyticsEvent)(lockedUnlocked + '-' + firstElementType.toLowerCase());
        }
    };
};

var LockTool = function LockTool(props) {
    return _react2.default.createElement(
        _Tool2.default,
        _extends({}, props, { name: props.name, isActive: props.isActive }),
        _react2.default.createElement(_Icon2.default, { name: props.isActive ? 'toolbar-lock-on' : 'toolbar-lock' })
    );
};

LockTool.propTypes = {
    name: _propTypes2.default.string,
    isActive: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LockTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/lockTool/LockTool.js
// module id = 2247
// module chunks = 0